<script>
import { AisSearchBox } from 'vue-instantsearch/vue3/es';
import SearchIcon from '@garmin/regalia/icons/ui-search/icon.vue';

export default {
  name: 'AlgoliaSearch',

  components: {
    AisSearchBox,
    SearchIcon,
  },

  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<template>
  <label>
    <span class="visually-hidden">{{ content.placeholderText }}</span>
  </label>
  <div class="algolia-search-container">
    <SearchIcon class="algolia-search-icon" />
    <ais-search-box :placeholder="content.placeholderText" />
  </div>
</template>

<style lang="scss">
.algolia-search-container {
  position: relative;
  margin: 0 1rem;

  @include breakpoint('lg') {
    max-width: 1200px;
    margin: 3rem auto;
    width: 100%;
  }

  .algolia-search-icon {
    position: absolute;
    left: 1rem;
    top: 50%;
    transform: translateY(-50%);
    width: 1rem;
    height: 1rem;
    fill: $color-black;
    pointer-events: none;
    z-index: 1;
  }
}

/*
  Algolia Style overrides
*/

.ais-SearchBox-form {

  .ais-SearchBox-input {
    width: 100%;
    border: solid 1px $color-gray-85;
    transition: border-bottom 0.25s ease;
    margin: 3rem 0;
    padding: 1rem 2rem 1rem 2rem;
    font-size: 1rem;
    @include font-primary();
    display: block;
    background: transparent;
    appearance: none;
    text-indent: 1rem;

    &::-webkit-search-cancel-button {
      appearance: none;
      display: none;
    }

    &:focus {
      outline: none;
      border: solid 1px $color-black;
    }
  }

  .ais-SearchBox-submit {
    display: none;
  }

  .ais-SearchBox-reset {
    position: absolute;
    inset-inline-end: 0;
    top: 50%;
    transform: translateY(-50%);
    padding: 0.9rem;
    background: $color-white;
    border: none;
    margin-inline-end: 0.5rem;
    cursor: pointer;
    @include breakpoint('lg') {
      inset-inline-end: 0;
    }
  }
}
</style>
